import { RefObject, useState } from 'react';

import { DropdownAlign } from './types';

export function useDropdownAutoAlign(panelRef: RefObject<HTMLElement>) {
  const [align, setAlign] = useState<DropdownAlign>();

  const handleFocus = () => {
    const panel = panelRef.current;
    const dropdown = panel?.closest('.dropdown');
    if (!panel || !dropdown) return;

    const { left } = dropdown.getBoundingClientRect();
    const { width } = panel.getBoundingClientRect();
    setAlign(left + width > window.innerWidth ? 'end' : undefined);
  };

  return { align, handleFocus };
}
